import { IEvaluationSection } from 'models/evaluation.model'
import { useEvaluation } from '../../contexts/Evaluation'
import { Question } from './styled'
import { QuestionTitle } from './questionTitle'
import Answers from './answers'
import MultimediaContent from './multimediaContent'
import AnswerExplanation from './answerExplanation'

interface IProps {
  section: IEvaluationSection
}

export const Questions = ({ section }: IProps) => {
  const { isSectionsInReviewMode, previewMode } = useEvaluation()

  return (
    <>
      {section.questions.map((question, index) => (
        <Question key={index}>
          <QuestionTitle
            question={question}
            isReviewing={isSectionsInReviewMode}
            index={index}
          />
          {question.multimediaContent && (
            <MultimediaContent question={question} />
          )}
          <Answers question={question} />
          {question.answerExplanation && (
            <AnswerExplanation value={question.answerExplanation} />
          )}
        </Question>
      ))}
    </>
  )
}

export default Questions
